export default "__VITE_ASSET__BvOqBN$Z__"